import { Component, OnInit, inject } from '@angular/core';

import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { ActivatedRoute } from '@angular/router';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { Global360View, UccxAgent, UccxAgentRef, UccxFieldConfig } from '../../../shared/models/generated/ziroModels';
import { combineLatest, Subscription, switchMap } from 'rxjs';
import { Global360ViewContext } from '../../../shared/contexts/global-360-view.context';
import { UcMetadataCacheContext } from '../../../shared/contexts/uc-metadata-cache.context';
import { UccxAgentResource } from '../../shared/resources/uccx-agent.resource';
import { UccxAgentFieldConfigResource } from '../../shared/resources/field-config/uccx-agent-field-config.resource';
import { UserDetailUiContext } from '../../shared/contexts/user-detail-ui.context';

@Component({
  selector: 'ziro-uccx-agent',
  templateUrl: './uccx-agent.component.html',
  standalone: false,
})
export class UccxAgentComponent implements OnInit {
  private breadcrumbsService = inject(BreadcrumbsService);
  private route = inject(ActivatedRoute);
  private global360ViewContext = inject(Global360ViewContext);
  private ucMetadataCacheContext = inject(UcMetadataCacheContext);
  private userDetailUiContext = inject(UserDetailUiContext);
  private uccxAgentResource = inject(UccxAgentResource);
  private uccxAgentFieldConfigResource = inject(UccxAgentFieldConfigResource);

  isLoading = true;
  username: string;
  serverId: string;
  ziroIcons = ZiroIcons;
  uccxAgentRef: UccxAgentRef;
  uccxAgent: UccxAgent;
  global360View: Global360View;
  fieldConfig: UccxFieldConfig;
  resourceGroups: string[];
  private _subscriptions = new Subscription();

  ngOnInit(): void {
    this.username = this.route.snapshot.paramMap.get('username');
    this.serverId = this.route.snapshot.paramMap.get('serverId');
    this.global360ViewContext.init(this.username);

    const subs = combineLatest([
      this.global360ViewContext.state$,
      this.ucMetadataCacheContext.state$,
      this.userDetailUiContext.state$,
    ])
      .pipe(
        switchMap(([global360View, ucMetadataCache]) => {
          this._updateBreadCrumb();
          this.global360View = global360View;
          if (global360View.uccxAgents.length > 0) {
            this.uccxAgentRef = this.global360ViewContext.getCurrentUccxAgent(global360View, Number(this.serverId));

            this.resourceGroups = ucMetadataCache.uccxMetadataCache[this.uccxAgentRef.serverId].resourceGroups;

            return combineLatest([
              this.uccxAgentResource.get(this.uccxAgentRef.serverId.toString(), this.uccxAgentRef.id.toString()),
              this.uccxAgentFieldConfigResource.getFieldConfigs(this.uccxAgentRef.serverId),
            ]);
          }
        }),
      )
      .subscribe(([uccxAgent, fieldConfig]) => {
        this.uccxAgent = uccxAgent;
        this.fieldConfig = fieldConfig;
        this.isLoading = false;
      });
    this._subscriptions.add(subs);
  }

  private _updateBreadCrumb(): void {
    this.breadcrumbsService.updateBreadcrumbs([
      {
        label: this.username,
        url: `/app2/#/user/${encodeURIComponent(this.username)}`,
      },
      {
        label: 'tkey;shared.service.agent.text',
      },
    ]);
  }
}
